import { useMemo } from 'react';

import { CertificateTemplateType } from '@/types/schema';

import { useCertificateTemplatesQuery } from '../graphql/queries/generated/certificateTemplates';

function useCertificateTemplate({ certificateId }: { certificateId?: string }) {
  const [certificateTemplatesResult] = useCertificateTemplatesQuery({
    variables: {
      filters: {
        certificateTemplateIds: [certificateId!],
      },
    },
    pause: !certificateId,
  });

  const certificateTemplates = useMemo(
    () =>
      (certificateTemplatesResult.data?.certificateTemplates?.edges?.map(({ node }) => node) ||
        []) as CertificateTemplateType[],
    [certificateTemplatesResult.data?.certificateTemplates?.edges],
  );

  return {
    fetching: certificateTemplatesResult.fetching,
    error: certificateTemplatesResult.error,
    certificateTemplate: certificateTemplates.length ? certificateTemplates[0] : null,
  };
}

export default useCertificateTemplate;
